import { AxiosError } from 'axios'
import router from '@/router'
import { setSnackbar } from '@/composables/useSnackbar'
import { getUserSessionStorage } from '@/composables/useSessions'

/*
A booking reference is short lived and bound to whoever it was issued to, so a
404 from a booking endpoint does not mean the booking is gone - it means the
visitor has to identify themselves again before a fresh reference can be minted.
Sitting on a dead-end error page is no use to them, so send them to whichever
lookup can actually issue one.

Never to the login page: /my-account/* is already behind the authenticate guard
in navigationGuards.ts, so anyone who reaches a booking page while signed out is
on the public route and is here as a guest. Asking them to sign in would be a
dead end, because they may well not have an account at all.
*/
export const isMissingBooking = (error: unknown): boolean =>
  (error as AxiosError)?.response?.status === 404

export const recoverBookingAccess = (): void => {
  if (getUserSessionStorage()?.AccessToken) {
    redirect(
      { name: 'MyAccountTickets' },
      'That booking link has expired. Please choose your booking again.'
    )
    return
  }

  redirect(
    { name: 'SearchTickets' },
    'That booking link has expired. Please look up your booking again.'
  )
}

const redirect = (location: Parameters<typeof router.push>[0], message: string) => {
  router.push(location).then(() => setSnackbar(message))
}
